import React from 'react';
import { Route } from 'react-router-dom';
import { compose, withHandlers, withState } from 'recompose';
import { get } from 'lodash';
import { BrowserRouter as Router } from 'react-router-dom';
import AppBar from './components/appBar';
import { withStyles } from '@material-ui/core/styles';

import withLoader from './modules/app/withLoader';
import Account from './modules/account';

import Users from './modules/users';
import AddUser from './modules/users/add';
import UserDetail from './modules/users/detail';

import Categories from './modules/categories';
import CategoryDetail from './modules/categories/detail';
import AddCategory from './modules/categories/add';

import Homepage from './modules/homepage';

import Services from './modules/services';
import ServiceDetail from './modules/services/detail';
import AddService from './modules/services/add';

import Attributes from './modules/attributes';
import AttributeDetail from './modules/attributes/detail';
import AddAttribute from './modules/attributes/add';
import AttributeValueDetail from './modules/attributes/detailValue';

import Products from './modules/products';
import ItemDetail from './modules/products/detailItem';
import ProductDetail from './modules/products/detail';
import AddProduct from './modules/products/add';

import Items from './modules/items';
import Reservations from './modules/reservations/';
import AddReservation from './modules/reservations/add';
import ReservationDetail from './modules/reservations/detail';
import { logout } from './modules/login/_api';
import AddAttributeValue from './modules/attributes/addValue';
import { withSnackbar } from 'notistack';
import ConfirmDialog from './components/confirmDialog';
import { deleteUser } from './modules/users/_api';
import { deleteAttribute, deleteAttributeValue } from './modules/attributes/_api';
import { deleteCategory } from './modules/categories/_api';
import { deleteProduct, deleteItem } from './modules/products/_api';
import { deleteService } from './modules/services/_api';
import { deleteReservation } from './modules/reservations/_api';
import moment from 'moment';
import { connect } from 'react-redux';
import Prices from './modules/prices/';
import { loadUser } from './modules/login/_api';

const styles = (theme) => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  appBar: {
    position: 'fixed',
  },
  layout: {
    width: 'auto',
    marginTop: 80,
  },
  toolbar: {
    justifyContent: 'space-between',
  },
  button: {
    margin: 5,
  },
});

const enhance = compose(
  withStyles(styles),
  connect((state) => ({
    isMiniMode: get(state, 'app.miniMode', false),
  }), { loadUser }),
  withLoader,
  withSnackbar,
  withState('dialog', 'setDialog', { open: false, id: null }),
  withState('reload', 'setReload', false),
  withHandlers({
    logout: ({ loadUser, toggleLoader }) => async () => {
      toggleLoader();
      await logout();
      await loadUser();
      toggleLoader(false);
    },
    handleConfirmDialog: ({
      dialog,
      toggleLoader,
      setReload,
      setDialog,
      enqueueSnackbar,
    }) => async () => {
      const id = get(dialog, 'id', false);
      const action = get(dialog, 'action', null);
      toggleLoader();
      if (id) {
        if (action === 'user-delete') {
          const resp = await deleteUser(id);
          if (get(resp, 'success', false)) {
            enqueueSnackbar('Uživatel úspěšně smazán.', { variant: 'success' });
          } else {
            enqueueSnackbar('Uživatele se nepodařilo smazat.', {
              variant: 'error',
            });
          }
        }
        if (action === 'category-delete') {
          const resp = await deleteCategory(id);
          if (get(resp, 'success', false)) {
            enqueueSnackbar('Kategorie úspěšně smazána.', {
              variant: 'success',
            });
          } else {
            enqueueSnackbar('Kategorii se nepodařilo smazat.', {
              variant: 'error',
            });
          }
        }
        if (action === 'attribute-delete') {
          const resp = await deleteAttribute(id);
          if (get(resp, 'success', false)) {
            enqueueSnackbar('Atributa úspěšně smazána.', {
              variant: 'success',
            });
          } else {
            enqueueSnackbar('Atributu se nepodařilo smazat.', {
              variant: 'error',
            });
          }
        }
        if (action === 'product-delete') {
          const resp = await deleteProduct(id);
          if (get(resp, 'success', false)) {
            enqueueSnackbar('Produkt úspěšně smazán.', { variant: 'success' });
          } else {
            enqueueSnackbar('produkt se nepodařilo smazat.', {
              variant: 'error',
            });
          }
        }
        if (action === 'attribute-value-delete') {
          const resp = await deleteAttributeValue(id);
          if (get(resp, 'success', false)) {
            enqueueSnackbar('Hodnota pro atributu úspěšně smazána.', {
              variant: 'success',
            });
          } else {
            enqueueSnackbar('Hodnotu pro atributu se nepodařilo smazat.', {
              variant: 'error',
            });
          }
        }
        if (action === 'item-delete') {
          const resp = await deleteItem(id);
          if (get(resp, 'success', false)) {
            enqueueSnackbar('Položka byla úspěšně smazána.', {
              variant: 'success',
            });
          } else {
            enqueueSnackbar('Položku se nepodařilo smazat.', {
              variant: 'error',
            });
          }
        }
        if (action === 'service-delete') {
          const resp = await deleteService(id);
          if (get(resp, 'success', false)) {
            enqueueSnackbar('Služba byla úspěšně smazána.', {
              variant: 'success',
            });
          } else {
            enqueueSnackbar('Službu se nepodařilo smazat.', {
              variant: 'error',
            });
          }
        }
        if (action === 'reservation-delete') {
          const resp = await deleteReservation(id);
          if (get(resp, 'success', false)) {
            enqueueSnackbar('Rezervace byla úspěšně smazána.', {
              variant: 'success',
            });
          } else {
            enqueueSnackbar('Rezervaci se nepodařilo smazat.', {
              variant: 'error',
            });
          }
        }
      }
      setDialog({ open: false, id: null, type: null });
      setReload(moment().format('YYYYMMDDHHmmss'));
      toggleLoader(false);
    },
  })
);

export default enhance(
  ({
    classes,
    isLoading,
    isLoggedIn,
    logout,
    dialog,
    setDialog,
    handleConfirmDialog,
    reload,
    location,
    isMiniMode
  }) => (
    <Router>
      <React.Fragment>
        <AppBar logout={logout} />
        <div>
          <main className={classes.layout} style={ isMiniMode ? { marginTop: 50 } : { marginTop: 80}}>
            <Route path="/account" exact component={Account} />
            <Route
              path="/users"
              exact
              render={(params) => <Users {...params} setDialog={setDialog} reload={reload} />}
            />
            <Route path="/users/add" exact component={AddUser} />
            <Route
              path="/users/:id(\d+)"
              exact
              render={(params) => <UserDetail {...params} setDialog={setDialog} reload={reload} />}
            />
            <Route
              path="/categories"
              exact
              render={(props) => <Categories {...props} setDialog={setDialog} reload={reload} />}
            />
            <Route path="/categories/:id/detail" exact component={CategoryDetail} />
            <Route path="/categories/add" exact component={AddCategory} />
            <Route
              path="/attributes"
              exact
              render={(props) => <Attributes {...props} setDialog={setDialog} reload={reload} />}
            />
            <Route
              path="/attributes/:id(\d+)"
              exact
              render={(params) => (
                <AttributeDetail {...params} setDialog={setDialog} reload={reload} />
              )}
            />
            <Route
              path="/attributes/:attributeId(\d+)/values/:id(\d+)"
              exact
              component={AttributeValueDetail}
            />
            <Route path="/attributes/add" exact component={AddAttribute} />
            <Route path="/attributes/:id(\d+)/add" exact component={AddAttributeValue} />
            <Route
              path="/products"
              exact
              render={(props) => <Products {...props} setDialog={setDialog} reload={reload} />}
            />
            <Route
              path="/products/:id"
              exact
              render={(props) => <ProductDetail {...props} setDialog={setDialog} reload={reload} />}
            />
            <Route path="/products/:productId/items/:itemId" exact component={ItemDetail} />
            <Route path="/products/add/category/:id" exact component={AddProduct} />
            <Route path="/items" exact component={Items} />
            <Route
              path="/services"
              exact
              render={(props) => <Services {...props} setDialog={setDialog} reload={reload} />}
            />
            <Route path="/services/add" exact component={AddService} />
            <Route
              path="/services/:id(\d+)"
              exact
              render={(props) => <ServiceDetail {...props} setDialog={setDialog} reload={reload} />}
            />
            <Route
              path="/reservations"
              exact
              render={(props) => <Reservations {...props} setDialog={setDialog} reload={reload} />}
            />
            <Route path="/reservations/add" exact component={AddReservation} />
            <Route
              path="/reservations/:id(\d+)"
              exact
              render={(props) => (
                <ReservationDetail {...props} setDialog={setDialog} reload={reload} />
              )}
            />
            <Route
              path="/reservations/:category([A-Za-z]+)"
              exact
              render={(props) => <Reservations {...props} setDialog={setDialog} reload={reload} />}
            />
            <Route path="/account" />
            <Route path="/prices" exact component={Prices} />
            <Route path="/" exact component={Homepage} />
          </main>
        </div>
        <ConfirmDialog
          open={get(dialog, 'open', false)}
          dialog={dialog}
          handleOk={() => handleConfirmDialog()}
          handleCancel={() => setDialog({ open: false, id: null, type: null })}
        />
      </React.Fragment>
    </Router>
  )
);



// WEBPACK FOOTER //
// ./src/Main.js